import React from "react";

import classNames from "classnames";
import { useDispatch } from "react-redux";
import { useCheckFeatureAccess } from "src/app/subscription/subscriptionFunctions";
import { setPlanUpgradeNeededModalContext } from "src/redux";
import { UniversalSettingsTab } from "../../SettingsModal";
import { TabButton } from "./getTabButtons";

interface TabButtonProps {
  button: TabButton;
  tab: UniversalSettingsTab;
  setTab: (tab: UniversalSettingsTab) => void;
}

export default function SidebarTabButton(props: TabButtonProps) {
  const { button, tab, setTab } = props;

  const dispatch = useDispatch();

  const hasFeatureAccess = useCheckFeatureAccess(button.feature);

  const handleTabChange = () => {
    if (hasFeatureAccess) {
      setTab(button.value);
    } else if (button.feature) {
      dispatch(setPlanUpgradeNeededModalContext(button.feature));
    }
  };

  return (
    <div
      key={button.value}
      className={classNames("settings-sidebar__item button-style-reset", {
        "settings-sidebar__item--active": button.value === tab,
      })}
      onClick={handleTabChange}
    >
      {button.label}
    </div>
  );
}
